module.exports = __webpack_public_path__ + "static/media/images_grp.a2eda771.png";